import React from 'react';
import { styled } from '@linaria/react';
import { SpacingPropsType } from 'types/Layout';
import { cssTheme } from '../../../themes';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The size of the left and right margins */
  sideMargin?: SpacingPropsType;
}
const _exp2 = /*#__PURE__*/() => ({
  sideMargin
}) => cssTheme.layout.spacing[sideMargin];
const DividerWrapper = /*#__PURE__*/styled('div')({
  name: "DividerWrapper",
  class: "drxr3ve",
  propsAsIs: false,
  vars: {
    "drxr3ve-0": [_exp2()]
  }
});
export const DividerElement = /*#__PURE__*/styled('div')({
  name: "DividerElement",
  class: "dwjcmeu",
  propsAsIs: false
});
export const Divider = ({
  sideMargin = 's000',
  className
}: Props) => <DividerWrapper sideMargin={sideMargin} className={className}>
    <DividerElement />
  </DividerWrapper>;

require("./Divider.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Divider.tsx");